import { render, staticRenderFns } from "./AchievementsColumn.vue?vue&type=template&id=21ba8c32"
import script from "./AchievementsColumn.vue?vue&type=script&lang=js"
export * from "./AchievementsColumn.vue?vue&type=script&lang=js"
import style0 from "./AchievementsColumn.vue?vue&type=style&index=0&id=21ba8c32&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports